import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { getFilterUrl, getType } from "../../../../../utils";
import styles from "./index.module.scss";
import { Select } from "../../../../common/select";
import TopMarks from "../marks";
import { setIsFilterLoading } from "../../../../../redux/action-creaters/filter";
import { Api } from "../../../../../api";

export default function Selector({ sectionPageUrl }) {
  const dispatch = useDispatch();
  const router = useRouter();
  const { autos } = useSelector((state) => state.user);
  const { marks, models, types } = useSelector((state) => state.models);
  const { params } = useSelector((state) => state.filter);

  const changeMark = (value) => {
    if (!value) {
      return;
    }
    if (typeof localStorage === "object") {
      localStorage.setItem("mark_", value);
      localStorage.setItem("model_", "");
      localStorage.setItem("type_", "");
    }
    dispatch(setIsFilterLoading(true));
    const url = getFilterUrl(sectionPageUrl, params, { marka: value });
    router.push(url);
  };

  const changeModel = (value) => {
    if (!value) {
      return;
    }
    if (typeof localStorage === "object") {
      localStorage.setItem("model_", value);
      localStorage.setItem("type_", "");
    }
    dispatch(setIsFilterLoading(true));
    router.push(getFilterUrl(sectionPageUrl, params, { model: value }));
  };

  const changeTypes = (value) => {
    if (!value) {
      return;
    }
    if (typeof localStorage === "object") {
      localStorage.setItem("type_", value);
      localStorage.setItem(
        "filterUrl",
        `/filter/marka-${params.marka?.[0]}/model-${params.model?.[0]}/kuzov-${value}`,
      );
    }
    dispatch(setIsFilterLoading(true));
    router.push(getFilterUrl(sectionPageUrl, params, { kuzov: value }));
  };

  // eslint-disable-next-line no-unused-vars
  const [isSelectOther, setIsSelectOther] = useState(false);

  const selectedAuto = useMemo(() => {
    return (
      autos &&
      autos.find((auto) => {
        if (
          auto.MARK_CODE === params.marka?.[0] &&
          auto.MODEL_CODE === params.model?.[0] &&
          auto.CODE === params.kuzov?.[0]
        ) {
          return true;
        }
        return false;
      })
    );
  }, [autos, params]);

  useEffect(() => {
    const somethingSelected =
      params.marka?.[0] || params.model?.[0] || params.kuzov?.[0];
    if (somethingSelected && !selectedAuto) {
      setIsSelectOther(true);
    }
  }, [params, selectedAuto]);

  const markKeys = Object.keys(marks).sort();
  const modelsKeys = Object.keys(models).sort();

  const [markTrigger, setMarkTrigger] = useState(0);
  const [modelTrigger, setModelTrigger] = useState(0);
  const [kuzovTrigger, setKuzovTrigger] = useState(0);

  useEffect(() => {
    setKuzovTrigger(1);
  }, [types]);

  const [isMarksLoaded, setIsMarksLoaded] = useState(false);
  const [markNames, setMarkNames] = useState();
  const translateMarkLibrary = useMemo(() => {
    const library = [];
    if (markNames) {
      Object.keys(markNames).forEach((markCode) => {
        if (markCode) {
          library.push([
            markCode,
            markNames[markCode].NAME?.trim().toLowerCase(),
            markNames[markCode].NAME_RUS?.trim().toLowerCase(),
          ]);
        }
      });
    }
    return library;
  }, [markNames]);

  const getMarkNames = async () => {
    if (!isMarksLoaded) {
      setIsMarksLoaded(true);
      const data = await Api.server.getMarkNames();
      setMarkNames(data);
    }
  };

  return markKeys.length > 0 ? (
    <>
      <div className={styles.Filter}>
        <div className={styles.Title}>Выберите автомобиль</div>
        <div className={styles.Selector}>
          <Select
            options={markKeys.map((markCode) => ({
              value: markCode,
              name: marks[markCode].NAME,
            }))}
            placeholder={"Марка"}
            selected={params?.marka}
            onChange={(value) => changeMark(value)}
            trigger={markTrigger}
            onOpened={() => {
              getMarkNames();
            }}
            searchTranslateLibrary={translateMarkLibrary}
          />
          <Select
            key={params?.marka?.[0]}
            options={modelsKeys?.map((modelCode) => ({
              value: modelCode,
              name: models[modelCode].NAME,
            }))}
            placeholder={"Модель"}
            isDisabled={modelsKeys.length === 0}
            selected={params?.model}
            onChange={(value) => changeModel(value)}
            onClickDisabled={() => {
              setMarkTrigger(markTrigger + 1);
            }}
            trigger={modelTrigger}
            onOpened={() => {
              // getMarkNames();
            }}
          />
          <Select
            key={params?.model?.[0]}
            options={
              types &&
              Object.keys(types)
                .map((typeCode) => getType(types[typeCode].NAME, typeCode))
                .sort((a, b) => a.sort - b.sort)
                .map((item) => ({
                  value: item.code,
                  name: `${item.name} ${item.gen}`,
                }))
            }
            placeholder={"Кузов"}
            isDisabled={!types || Object.keys(types).length === 0}
            selected={params?.kuzov}
            onChange={(value) => changeTypes(value)}
            onClickDisabled={() => {
              setModelTrigger(modelTrigger + 1);
            }}
            trigger={kuzovTrigger}
          />
        </div>
      </div>
      {!params?.marka && (
        <TopMarks sectionUrl={sectionPageUrl} markKeys={markKeys} />
      )}
    </>
  ) : null;
}
